import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Report error to Sentry.
    // `errorInfo.componentStack` contains React stacktrace
    if (window.Raven) {
      window.Raven.captureException(error, { extra: errorInfo });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.showAlert) {
        return (
          <div id="error">
            {this.props.title && <h1>{this.props.title}</h1>}
            {this.props.message && (
              <p
                dangerouslySetInnerHTML={{
                  __html: this.props.message,
                }}
              />
            )}
          </div>
        );
      }

      return null;
    }

    // when there's no error, render children untouched
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  showAlert: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
};
ErrorBoundary.defaultProps = {
  showAlert: true,
  title: null,
  message: null,
};
